import css from 'styled-jsx/css';

export default css`
  .banner-shipping-wrapper {
    background: linear-gradient(91.01deg, #00dcbb -32.37%, #0097ad 85.19%);
    padding: 20px 12px;
  }
  .banner-shipping {
    max-width: 1200px;
    margin: auto;
  }
  .banner-shipping p {
    font-size: 15px;
    font-weight: 500;
    line-height: 12px;
    color: white !important;
  }
  .icon-bg {
    background: white;
    border-radius: 50px;
  }
  .icon-bg img {
    padding: 4px;
  }

  @media all and (max-width: 600px) {
    .banner-shipping p {
      max-width: 70px;
    }
    .banner-shipping-wrapper {
      background: linear-gradient(91.01deg, #00dcbb -32.37%, #0097ad 85.19%);
      padding: 10px 12px;
    }
    .banner-shipping p {
      font-size: 12px;
      color: white;
      font-weight: 500;
      line-height: 12px;
    }
    .icon-bg {
      background: white;
      border-radius: 50px;
    }
    .icon-bg img {
      width: 100%;
      padding: 4px;
      max-height: 30px;
    }
  }
`;
